module.exports = __webpack_public_path__ + "static/media/mobile6.4ff716f2.png";